export default function Tooltip({
  icon,
  demo,
  title,
  rotate,
  description,
  link,
  emoji,
}) {
  return (
    <div className="group relative">
      <div className="md:block hidden absolute left-1/2 -top-56 -translate-x-1/2 scale-0 transform rounded-md bg-white shadow-lg transition-all duration-200 group-hover:scale-100 w-64 border-2 p-1.5">
        <img src={demo} className="aspect-video w-full rounded-t-md" />

        <div className="flex gap-2 pt-2">
          <div className="h-10 w-10 rounded-lg bg-gray-200 text-center p-1">
            {emoji}
          </div>
          <div className="">
            <p className="text-sm font-semibold">{title}</p>
            <p className="text-sm">{description}</p>
          </div>
        </div>
      </div>

      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="rotate-3"
      >
        <img
          src={icon}
          className={`hover:rotate-0 hover:border-blue-500 hover:scale-110 hover:z-10 rounded-3xl aspect-square object-cover bg-bottom transition-transform duration-150 border-2 ${
            rotate < 0 ? `-rotate-3` : `rotate-3`
          }`}
        />
      </a>
    </div>
  );
}
